import React from "react";
import QuickViewModalAdapter from "@lululemon/ecom-common/src/components/quick-view-modal-adapter";
import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";
import { OutfitsInspirationComponent } from "@lululemon/pdp-outfit";
import useQuickViewModal from "./hooks/useQuickViewModal.js";
import { usePDPRefs } from "../../context/pdp-refs.context";
import { useRouter } from "next/router";
import { useGetFindmineData } from "./hooks/hooks";
import styles from "./outfits-inspiration-wrapper.module.scss";
import { FM_EVENTS, trackFMEvent } from "./fm-analytics/fm-analytics";
import {
  trackEvent,
  EVENT_CATEGORY,
  EVENT_TYPE,
} from "@lululemon/mwa-analytics";
import classNames from "classnames";

const OutfitsInspirationWrapper = () => {
  const { deviceType } = useDeviceType();
  const { locale } = useRouter();
  const { selectedProduct, setSelectedProduct, handleProductSelected } =
    useQuickViewModal();
  const { shouldShow, outfits: looks, seedItem, uuId } = useGetFindmineData();
  const { outfitInspirationRef } = usePDPRefs();
  const { isMobile } = deviceType || {};

  if (!shouldShow) return null;

  return (
    <>
      <h2 className={classNames(styles.header, "OneLinkTx")}>
        Outfit inspiration
      </h2>
      <OutfitsInspirationComponent
        onHandleProductSelected={handleProductSelected}
        shouldShow={shouldShow}
        looks={looks}
        seedItem={seedItem}
        outfitInspirationRef={outfitInspirationRef}
        locale={locale}
        uuId={uuId}
        fmEvents={FM_EVENTS}
        trackFMEvent={trackFMEvent}
        trackEvent={trackEvent}
        EVENT_CATEGORY={EVENT_CATEGORY}
        EVENT_TYPE={EVENT_TYPE}
        PDPRefs={usePDPRefs}
      />
      <QuickViewModalAdapter
        config={{
          productId: selectedProduct?.productId,
          visible: !!selectedProduct,
          defaultColorCode: selectedProduct?.colorId,
          productPosition: selectedProduct?.productPosition,
          productCategoryUnifiedId: selectedProduct?.categoryUID,
          productUnifiedId: selectedProduct?.selectedProductUID,
          onClose: () => {
            setSelectedProduct(null);
          },
          hideViewDetails: selectedProduct?.productPosition === 1,
          isMobile,
          isSeedProduct: selectedProduct?.productPosition === 1,
        }}
      />
    </>
  );
};

export default OutfitsInspirationWrapper;
